<template>
    <v-dialog
        :value="value"
        @input="$emit('input', $event)"
        max-width="500px"
        @click:outside="closeModal"
    >
        <v-card class="pa-6">
            <div class="modal-close-btn">
                <v-btn icon @click="closeModal">
                    <v-icon size="18" color="grey">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card-title class="d-flex justify-center pb-4">
                <span class="headline pa-0">Change Your Password</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col class="pb-0">
                        <v-text-field
                            outlined
                            type="password"
                            label="Current Password"
                            v-model="credentials.password"
                            :error-messages="passwordErrors"
                            @input="$v.credentials.password.$touch()"
                            @blur="$v.credentials.password.$touch()"
                            hide-details="auto"
                            class="btn-edu-height"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pb-0">
                        <v-text-field
                            outlined
                            type="password"
                            label="New Password"
                            v-model="credentials.newPassword"
                            :error-messages="newPasswordErrors"
                            @input="$v.credentials.newPassword.$touch()"
                            @blur="$v.credentials.newPassword.$touch()"
                            hide-details="auto"
                            class="btn-edu-height"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pb-0">
                        <v-text-field
                            outlined
                            type="password"
                            label="Confirm New Password"
                            v-model="credentials.confirmNewPassword"
                            :error-messages="confirmNewPasswordErrors"
                            @input="$v.credentials.confirmNewPassword.$touch()"
                            @blur="$v.credentials.confirmNewPassword.$touch()"
                            hide-details="auto"
                            class="btn-edu-height"
                            @keyup.enter="updatePassword"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="d-flex mt-4">
                    <v-col cols="6" class="pb-0">
                        <v-btn
                            color="primary"
                            height="45"
                            class="btn-edurent"
                            depressed
                            block
                            @click="updatePassword"
                            :loading="isUpdatingPassword"
                        >Save Changes</v-btn>
                    </v-col>
                    <v-col cols="6" class="pb-0">
                        <v-btn
                            color="primary"
                            height="45"
                            class="btn-edurent"
                            depressed
                            block
                            outlined
                            @click="closeModal"
                        >Cancel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import UserService from '../services/user.service'

export default {
    name: 'ChangePasswordModal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        userId: {
            type: Number,
            required: true
        }
    },
    validations: {
        credentials: {
            password: { required },
            newPassword: { required },
            confirmNewPassword: { required, sameAsPassword: sameAs('newPassword') }
        }
    },
    data() {
        return {
            credentials: {
                password: '',
                newPassword: '',
                confirmNewPassword: ''
            },
            isUpdatingPassword: false
        }
    },
    computed: {
        passwordErrors() {
            const errors = []
            if (!this.$v.credentials.password.$dirty) return errors
            !this.$v.credentials.password.required && errors.push('Password is required')
            return errors
        },
        newPasswordErrors() {
            const errors = []
            if (!this.$v.credentials.newPassword.$dirty) return errors
            !this.$v.credentials.newPassword.required && errors.push('New password is required')
            return errors
        },
        confirmNewPasswordErrors() {
            const errors = []
            if (!this.$v.credentials.confirmNewPassword.$dirty) return errors
            !this.$v.credentials.confirmNewPassword.required && errors.push('New password confirmation is required')
            !this.$v.credentials.confirmNewPassword.sameAsPassword && errors.push('Password confirmation must match password value')
            return errors
        }
    },
    methods: {
        resetForm() {
            this.credentials = {
                password: '',
                newPassword: '',
                confirmNewPassword: ''
            }
            this.$v.$reset()
        },
        closeModal() {
            this.resetForm()
            this.$emit('input', false)
        },
        async updatePassword() {
            this.$v.credentials.$touch()
            if (this.$v.credentials.$invalid) {
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'Mandatory field(s) required for changing your password is missing',
                    color: 'red'
                })
                return
            }

            let hasErrors = false
            this.isUpdatingPassword = true
            await UserService.updateSignedInPassword(this.userId, { credentials: this.credentials }).catch(() => {
                hasErrors = true
            })
            this.isUpdatingPassword = false

            if (hasErrors) {
                return
            }

            this.closeModal()
        }
    },
    watch: {
        value(newVal) {
            if (!newVal) {
                this.resetForm()
            }
        }
    }
}
</script>

<style scoped>
.headline {
    font-weight: 700 !important;
    font-size: 20px !important;
    font-family: 'Poppins', sans-serif !important;
}
</style>
